import { AccountDesignerPreferencesVertical } from '../../useDesigners';
import { useDesignerPreferences } from '../useDesignerPreferences';
import { DesignerPreferencesQueryItem } from '../useDesignerPreferences.rest';

export const isDesignerFollowed = (
  followedDesigners: DesignerPreferencesQueryItem[] | undefined,
  designerId: string | undefined
) =>
  followedDesigners != null &&
  designerId != null &&
  followedDesigners.find(designer => designer.designerId === Number(designerId)) !== undefined;

export const useIsDesignerFollowed = (
  vertical: AccountDesignerPreferencesVertical,
  designerId?: string
) => {
  const { data: followedDesigners, loading } = useDesignerPreferences(vertical);

  return {
    isFollowed: isDesignerFollowed(followedDesigners, designerId),
    loading
  };
};
